import { CSSProperties, ReactElement, SyntheticEvent } from "react";

import { makeStyles } from "@mui/styles";
import MuiButton, { ButtonProps } from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

type ButtonSubmitBottomProps = {
  title: string | ReactElement;
  loading?: boolean;
  disabled?: boolean;
  sx?: ButtonProps["sx"];
  style?: CSSProperties;
  outline?: boolean;
  component?: "button" | "div";
  onClick?: () => void;
};

const useStyles = makeStyles(() => ({
  submitButton: {
    "&.MuiButton-root": {
      padding: "8px 14px",
      color: "white",
      borderRadius: "12px",
      width: "100%",
      fontSize: "1.14286rem",
      textTransform: "none",
      boxShadow: "none",
      fontWeight: "bold",
      alignItems: "center",
      "&:has( > .icon)": { alignItems: "baseline" },
      "&:hover": {
        background: "var(--primary-theme-color)",
        boxShadow: "none",
        opacity: 0.9,
      },
      "&.outline": {
        background: "transparent",
        border: "1px solid var(--primary-theme-color)",
        color: "var(--primary-theme-color)",
      },
      "&:not(.Mui-disabled):not(.outline)": {
        background: "var(--primary-theme-color)",
      },
      "& .icon, & img": { marginRight: "0.5rem" },
    },
  },
  circularProgress: {
    marginRight: 0,
    marginLeft: "1rem",
    "& svg": { color: "white" },
  },
}));

const ButtonSubmitBottom = (props: ButtonSubmitBottomProps) => {
  const classes = useStyles();

  const handleClick = (e: SyntheticEvent) => {
    e.stopPropagation();

    if (props.loading) {
      return;
    }

    props.onClick?.();
  };

  return (
    <div
      style={{
        padding: "0 0.5rem 1rem",
        width: "100%",
        margin: "auto 0 0",
        ...props.style,
      }}
    >
      <MuiButton
        component={props.component || "button"}
        variant="contained"
        size="large"
        color="primary"
        sx={props.sx}
        className={`${classes.submitButton} ${props.outline ? "outline" : ""}`}
        onClick={handleClick}
        disabled={props.disabled}
      >
        {props.title}
        {props.loading && <CircularProgress className={classes.circularProgress} size={20} />}
      </MuiButton>
    </div>
  );
};

export default ButtonSubmitBottom;
